export const SUPPORT_ORIGIN = 'https://support.maxpreps.com';

const BASE_URL = `${SUPPORT_ORIGIN}/hc/en-us`;

export const SUPPORT_INTERNATIONAL_SCHOOLS = `${BASE_URL}/articles/4406235938459-International-School-on-MaxPreps`;
export const SUPPORT_INACTIVE_TEAM = `${BASE_URL}/articles/4406236028059-Inactive-Teams-and-Schools-on-MaxPreps `;

export const SUPPORT_CONTRIBUTE_TO_THE_TEAM = `${BASE_URL}/articles/1260801147750`;

export const SUPPORT_COACHES_TEAM_ADMINS = `${BASE_URL}/categories/200157654-Coaches-Team-Admins`;

export const SUPPORT_INCORRECT_STANDINGS = `${BASE_URL}/articles/360050389594-Incorrect-Team-Standings`;
export const SUPPORT_INCORRECT_RANKINGS = `${BASE_URL}/articles/202302030-Incorrect-Team-Rankings`;

export const SUPPORT_CORRECTIONS = `${BASE_URL}/articles/5781441994779`;
export const SUPPORT_SCHEDULE_CORRECTIONS = `${BASE_URL}/articles/4418837516443`;

export const SUPPORT_ROSTER_MANAGEMENT = `${BASE_URL}/articles/202055534-Roster-Management`;
export const SUPPORT_SCHEDULE_MANAGEMENT = `${BASE_URL}/articles/202055604-Schedule-Management`;

export const SUPPORT_ROSTER_SUBMISSIONS = `${BASE_URL}/articles/360049240833-Roster-Submissions`;
export const SUPPORT_SCHEDULE_SUBMISSIONS = `${BASE_URL}/articles/360049240773-Schedule-Submissions`;

export const SUPPORT_PURCHASING_PRO_PHOTOS = `${BASE_URL}/articles/202469870-Purchasing-Professional-Photos`;

export const SUPPORT_COACH_ADMIN_ACCESS = `${BASE_URL}/articles/4411806774683`;

export const SUPPORT_MANAGING_HUDL_ROSTERS = `${BASE_URL}/articles/223740747-Managing-your-Rosters-from-Hudl`;

export const SUPPORT_GAMECHANGER = `${BASE_URL}/articles/208478467-GameChanger-Sync-with-MaxPreps`;

export const SUPPORT_STAT_FAQ = `${BASE_URL}/articles/4404593358107`;
